import { UtilityService } from '@eforall/common';
import { GridColumn, buildColumn } from '@eforall/dashboard';
import { AccMentorDropout } from '../mentor-dropouts-grid.part';


export function getColumns(util: UtilityService) {

	const columns: GridColumn<AccMentorDropout, unknown>[] = [
		buildColumn(util, 'Id', row => row.accId, { header: 'accId' }),
		buildColumn(util, 'Text', row => row.accName, { header: 'AccName', width: 40, group: 'asc' }),
		buildColumn(util, 'Text', row => row.facilitatorName, { header: 'PF Name', hidden: true }),
		buildColumn(util, 'Id', row => row.accMentorId, { header: 'accMentorId' }),
		buildColumn(util, 'FullName', row => row.name, { header: 'Name', width: 80 }),
		buildColumn(util, 'Number', row => row.dropoutWeek, { header: 'Dropout Week', width: 40 }),
		buildColumn(util, 'Text', row => row.dropoutReason, { header: 'Dropout Reason', width: 60 }),
		buildColumn(util, 'Text', row => row.notes, { header: 'Notes' }),
	];


	return columns;

}